import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';
import { Activity } from '../activities';

@Component({
	selector: 'app-generate-activities-test',
	templateUrl: './generate-activities-test.component.html',
	styleUrls: ['./generate-activities-test.component.scss']
})

export class GenerateActivitiesTestComponent implements OnInit, AfterViewInit, OnDestroy {

	activityType = '';
	textSource = '';
	userID: number = 0;
	courseID: number = 0;
	courseUnits?: any[];
	selectedUnit = -1;
	unitLessons?: any[];
	selectedLesson = -1;
	numDistractors = 3;
	numQuestions = 2;
	activitiesText = '';
	activitiesResult?: Activity[];
	activitiesResultText = '';
	resetActivities = true;

	activitiesBtnDisabled = true;
	generateActivitiesLoading = false;
	generateActivitiesSuccess = false;
	generateActivitiesError = false;
	insertActivitiesLoading = false;
	insertActivitiesSuccess = false;
	insertActivitiesError = false;

	showCourseSub!: Subscription;
	generateActivitiesSub!: Subscription;
	taskStatusCelerySub!: Subscription;
	insertActivitiesSub!: Subscription;

	constructor(private dataService: ApiService, private route: ActivatedRoute) { }

	ngOnInit() {
		this.textSource = '';
		this.userID = this.dataService.getUserID();
		this.courseID = +this.route.snapshot.paramMap.get('id')!;
	}

	ngAfterViewInit() {
		this.showCourseSub = this.dataService.getCourse(this.courseID, this.userID)
		.subscribe(
			course => {
				// console.log(course);
				this.courseUnits = course.units;
			},
			error => {
				console.log(error);
			},
		);
	}

	ngOnDestroy() {
		this.showCourseSub?.unsubscribe();
		this.generateActivitiesSub?.unsubscribe();
	}

	reset() {
		this.activitiesText = '';
		this.activitiesResult = undefined;
		this.selectedUnit = -1;
		this.selectedLesson = -1;
		this.unitLessons = undefined;
		this.activitiesBtnDisabled = true;
		this.generateActivitiesLoading = false;
		this.generateActivitiesError = false;
		this.generateActivitiesSuccess = false;
		this.insertActivitiesLoading = false;
		this.insertActivitiesError = false;
		this.insertActivitiesSuccess = false;
	}

	selectUnit(unitId: number) {
		this.unitLessons = this.courseUnits?.find((unit) => {
			return +unitId === +unit.id;
		})?.lessons;

		this.selectedLesson = -1;
		this.activitiesBtnDisabled = true;

		if (this.unitLessons?.length === 1) {
			this.selectLesson(this.unitLessons[0].id);
		}
	}

	selectLesson(lessonId: number) {
		this.selectedLesson = lessonId;
		this.activitiesBtnDisabled = false;
		// console.log(this.selectedLesson);
		// console.log(this.selectedLessonName);
	}

	changeActivitiesText() {
		this.activitiesBtnDisabled = this.activitiesText === '';
	}

	generateActivities() {
		// console.log(btn);

		if (this.textSource === 'text') {
			// this.activitiesText = this.textArea.nativeElement.value;
			console.log(this.activitiesText);
		}
		this.activitiesResult = undefined;
		this.activitiesBtnDisabled = true;
		this.generateActivitiesLoading = true;
		this.generateActivitiesSuccess = false;
		this.generateActivitiesError = false;

		this.generateActivitiesSub = this.dataService.generateActivitiesTest(this.activityType, this.textSource, this.courseID, this.selectedUnit, this.selectedLesson, this.activitiesText, this.numDistractors, this.numQuestions)
		.subscribe(
			data => {
				console.log(data);
				let task = data.id;
				let module = '';
				if (this.activityType === 'activity') module = 'activity';
				else if (this.activityType === 'test') module = 'question';

				let interval = 1000 * 60 * 0.07;
				let idinterval = setInterval(() => {
					this.taskStatusCelerySub = this.dataService.taskStatusCelery(module, task)
					.subscribe(
						data => {
							console.log(data);
							let status = data.status;
							this.activitiesResult = data.result.activity_list;

							if (status !== "STARTED") {

								window.clearTimeout(idinterval);
								this.activitiesBtnDisabled = false;
								this.generateActivitiesLoading = false;
								this.activitiesResultText = data.result.message;
								
								if (status === "ERROR" || this.activitiesResult === null || this.activitiesResult!.length === 0) {
									// window.clearTimeout(idinterval);
									this.generateActivitiesSuccess = false;
									this.generateActivitiesError = true;
									return;
								}
								
								if (status === "SUCCESS") {
									this.generateActivitiesSuccess = true;
									this.generateActivitiesError = false;
								}

							}

						},
						error => {
							console.log(error);
							window.clearTimeout(idinterval);
							this.activitiesBtnDisabled = false;
							this.generateActivitiesLoading = false;
							this.generateActivitiesError = true;
						},
					);
				}, interval);
			},
			error => {
				console.log(error);
				this.activitiesBtnDisabled = false;
				this.generateActivitiesLoading = false;
				this.generateActivitiesError = true;
			},
		);

	}

	trackByFn(index: any, item: any) {
		return index;
	}

	newOption(activityIndex: number) {
		this.activitiesResult![activityIndex].options.push("Nueva opción");
	}

	changeOption(activityIndex: number, optionIndex: number, newOption: any) {
		let activity = this.activitiesResult![activityIndex];
		let solution = activity.solution;
		let option = activity.options![optionIndex];
		if (option === solution) this.activitiesResult![activityIndex].solution = newOption;
		this.activitiesResult![activityIndex].options![optionIndex] = newOption;
	}

	deleteOption(activityIndex: number, optionIndex: number) {
		this.activitiesResult![activityIndex].options.splice(optionIndex, 1);
	}

	saveActivities() {
		console.log(this.activitiesResult);

		this.insertActivitiesLoading = true;
		this.insertActivitiesError = false;
		this.insertActivitiesSuccess = false;
		this.insertActivitiesSub = this.dataService.addActivitiesTest(this.activityType!, this.courseID, this.selectedUnit, this.selectedLesson, this.activitiesResult!, this.resetActivities)
		.subscribe(
			data => {
				console.log(data);
				this.insertActivitiesLoading = false;
				this.insertActivitiesError = false;
				this.insertActivitiesSuccess = true;
			},
			error => {
				console.log(error);
				this.insertActivitiesLoading = false;
				this.insertActivitiesSuccess = false;
				this.insertActivitiesError = true;
			},
		);
	}

}
